var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var InheritanceSpecifier = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var parts = [path.call(_print, 'baseName')];

    if (node.arguments && node.arguments.length) {
      parts.push('(');
      parts = parts.concat(path.map(_print, 'arguments'));
      parts.push(')');
    }

    return concat(parts);
  }
};
module.exports = InheritanceSpecifier;